// Author Lin
// Date 2021-10-20 16:53:01

import * as model from "@/model/mintalMes/inventory/MintalMesInventoryMaterialQuantityModel.js";
import {newEntityStoreHelper} from "@/store/common/entityModule";

function newFilter(paginationFilter = {}) {
    var filter = Object.assign({}, paginationFilter, model.filter)
    return filter;
}

export default newEntityStoreHelper(() => new model.MintalMesInventoryMaterialQuantity(),newFilter)
    .withStates({
        baseModuleUrl: process.env.VUE_APP_MINTALMES_INVENTORY_URL,
    })
    .buildStore()
